<template>
  <div :style="{ width: width + 'px', height: height + 'px' }" style="margin:0 auto;">
    <div id="canvas"></div>
  </div>
</template>

<script>
export default {
  name: 'ringmaker-mini',
  props: ['width', 'height', 'estilo', 'laterales', 'adorno', 'color'],
  data () {
    return {
      three: {
        scene: {},
        camera: {},
        renderer: {},
        update: {},
        animate: {},
        controls: {},
        ambientLight: {}
      },
      texturas: [
        {
          id: 'diamante',
          ruta: 'static/assets/img/ringmaker/texturas/diamante/',
          archivos: [ 'posx.png', 'negx.png', 'posy.png', 'negy.png', 'posz.png', 'negz.png' ],
          transparencia: 0.8
        }, {
          id: 'oro_amarillo',
          ruta: 'assets/img/ringmaker/texturas/oro/',
          archivos: [ 'posx.jpg', 'negx.jpg', 'posy.jpg', 'negy.jpg', 'posz.jpg', 'negz.jpg' ],
          transparencia: 1
        }, {
          id: 'oro_blanco',
          ruta: 'assets/img/ringmaker/texturas/oro-blanco/',
          archivos: [ 'posx.jpg', 'negx.jpg', 'posy.jpg', 'negy.jpg', 'posz.jpg', 'negz.jpg' ],
          transparencia: 1
        }, {
          id: 'oro_rosa',
          ruta: 'assets/img/ringmaker/texturas/oro-rosa/',
          archivos: [ 'posx.jpg', 'negx.jpg', 'posy.jpg', 'negy.jpg', 'posz.jpg', 'negz.jpg' ],
          transparencia: 1
        }
      ],
      carpetaObjs: 'assets/obj/',
      cache: {}
    }
  },
  methods: {
    init () {
      const THREE = window.THREE
      // THREE Init
      this.three.scene = new THREE.Scene()
      this.three.scene.background = new THREE.Color('#FFFFFF')
      // THREE Camera
      this.three.camera = new THREE.PerspectiveCamera(45, window.innerWidth / window.innerHeight, 0.1, 1000)
      this.three.camera.position.x = 45
      this.three.camera.position.y = 75
      this.three.camera.position.z = 45
      this.three.camera.rotation.x = 45
      this.three.camera.aspect = this.width / this.height
      this.three.camera.lookAt(this.three.scene.position)
      this.three.camera.perspective = 'Perspective'
      this.three.camera.updateProjectionMatrix()
      // THREE Renderer
      this.three.renderer = new THREE.WebGLRenderer({ antialias: true, preserveDrawingBuffer: true })
      this.three.renderer.setSize(this.width, this.height)
      // Append Renderer to three
      document.getElementById('canvas').appendChild(this.three.renderer.domElement)

      // THREE Controls
      this.three.controls = new THREE.OrbitControls(this.three.camera, this.three.renderer.domElement)
      this.three.controls.enableDaming = true
      this.three.controls.dumpingFactor = 0.25
      this.three.controls.enableZoom = true
      this.three.controls.minDistance = 20
      this.three.controls.maxDistance = 30
      this.three.controls.update()
      this.three.controls.autoRotate = false
      this.three.controls.enablePan = false

      this.three.animate = () => {
        requestAnimationFrame(this.three.animate)
        this.three.renderer.render(this.three.scene, this.three.camera)
      }

      this.three.animate()

      // THREE Lights
      const ambientLight = new THREE.AmbientLight(0xffffff, 1)
      this.three.scene.add(ambientLight)
    },
    async cargarTexturas () {
      try {
        this.texturas.forEach(async (textura, index) => {
          const texturaCargada = await this.cargarTextura(textura.ruta, textura.archivos, textura.transparencia)
          this.$set(this.texturas, index, { id: textura.id, cache: texturaCargada })
        })
      } catch (err) {}
    },
    async desplegarAnillo () {
      try {
        let obj = await this.cargarOBJ(this.carpetaObjs + 'C11F11A.zip')
        obj = await this.aplicarTextura(obj, this.texturaCacheada('oro_amarillo'))
        this.agregarOBJ(obj)
      } catch (err) { console.log(err) }
    },
    limpiarScene () {
      for (let i = this.three.scene.children.length - 1; i >= 0; i--) {
        if (this.three.scene.children[i].type !== 'AmbientLight') {
          this.three.scene.remove(this.three.scene.children[i])
        }
      }
    },
    cargarOBJ (ruta) {
      return new Promise((resolve, reject) => {
        const loader = new window.THREE.OBJLoader()
        try {
          loader.loadObjZip(ruta, obj => {
            resolve(obj)
          })
        } catch (err) {
          console.log(err)
        }
      })
    },
    cachearOBJ (prop, obj) {
      this.cache[prop] = obj
    },
    agregarOBJ (obj) {
      this.three.scene.add(obj)
      return obj
    },
    cargarTextura (ruta, archivos, transparencia) {
      return new Promise((resolve, reject) => {
        const cargador = new window.THREE.CubeTextureLoader()
        cargador.setPath(ruta).load(archivos, textura => {
          textura.transparencia = transparencia
          resolve(textura)
        })
      })
    },
    async aplicarTextura (obj, textura) {
      return new Promise((resolve, reject) => {
        if (obj.traverse && textura) {
          obj.traverse(item => {
            if (item instanceof window.THREE.Mesh) {
              item.material.needsUpdate = true
              item.material.envMap = textura
              if (textura.transparencia) {
                item.material.transparent = true
                item.material.opacity = textura.transparencia
              }
            }
          })
          resolve(obj)
        } else {
          resolve(obj)
        }
      })
    },
    texturaCacheada (id) {
      return this.texturas.find(textura => { return textura.id === id }).cache
    },
    generarCodigoAro () {
      let codigo = ''
      codigo += this.anillo.estilo.codigo
      codigo += this.anillo.cana.codigo
      codigo += this.anillo.pexterno.codigo
      codigo += this.anillo.lateral.codigo
      codigo += this.anillo.adorno.codigo
      return codigo
    },
    generarCodigoProng () {
      let codigo = ''
      codigo += this.anillo.decorativo.codigo
      codigo += this.anillo.corte.codigo
      codigo += this.anillo.peso.codigo
      return codigo
    },
    sacarCaptura () {
      this.three.controls.reset()
      this.three.renderer.render(this.three.scene, this.three.camera)
      this.$evento.$emit('capturaRealizada', this.three.renderer.domElement.toDataURL('image/png'))
    },
    resetearPosicionAnillo () {
      this.three.controls.reset()
    }
  },
  created () {
  },
  async mounted () {
    try {
      await this.cargarTexturas()
      this.init()

      setTimeout(() => {
        this.desplegarAnillo()
        window.scrollTo(0, 1)
      }, 1000)
    } catch (err) {}
  }
}
</script>
